import { useState } from 'react'
import { Button, Col, Collapse, Container, FloatingLabel, Form, Row } from 'react-bootstrap'
import { BsFilterRight } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import NoReports from '../components/NoReports'
import UserSelector from '../components/UserSelector'
import Activity from '../components/Activity'
import { useGetCategoriesQuery } from '../redux/api/aggregateApi'
import { useGetReportsQuery } from '../redux/api/brainApi'
import { useGetSpecialitiesQuery } from '../redux/api/specialityApi'
import Cummulative from './Cummulative'

const SubjectInsights = () => {
  let initialValues = { category: 'all', speciality: 'all', gender: 'all', date: 'all', minAge: 2, maxAge: 99 }
  const [filters, setFilters] = useState(initialValues)
  const [show, setShow] = useState(false)

  const { selectedUser } = useSelector((state) => state.user)
  const { data: reports, isLoading: isReports } = useGetReportsQuery({ id: selectedUser?.id, test_area: 'one' }, { skip: !selectedUser })

  const { data: categories, isLoading: isCategories } = useGetCategoriesQuery()
  const { data: specialities, isLoading: isSpecialities } = useGetSpecialitiesQuery()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFilters((old) => ({ ...old, [name]: value }))
  }

  const reset = () => setFilters(initialValues)

  return (
    <>
      <div className='d-print-none'>
        <div className='dashboard-heading'>
          <div className='content-container'>
            <h2>Report</h2>
            <p>Here’s a quick overview for your reports</p>
          </div>
          <Activity />
        </div>
        <p className='m-0'>Showing results for:</p>
        <UserSelector />
      </div>

      {isReports ? (
        <p>Loading...</p>
      ) : !reports || reports.length === 0 ? (
        <div className='d-flex justify-content-center'>
          <NoReports />
        </div>
      ) : (
        <Container fluid='lg' className='mt-2'>
          {/* Filters */}
          <div className='d-print-none bg-white position-sticky top-0 d-flex flex-column' style={{ zIndex: 9 }}>
            <button
              onClick={() => setShow((p) => !p)}
              className=' fs-5 fw-bold rounded-pill px-3 py-1 border-0 align-self-end'
              style={{ background: 'var(--green-highlight-color)', color: 'var(--green-color)' }}
            >
              Filter <BsFilterRight style={{ fontSize: '28px', color: 'var(--green-color)', strokeWidth: '1' }} />
            </button>
            <Collapse in={show}>
              <div>
                <Row className='p-4'>
                  <Col md={6} lg={4} xl={3}>
                    <FloatingLabel controlId='floatingSelect' label='Category'>
                      <Form.Select required value={filters.category} onChange={handleChange} name='category'>
                        <option value='all'>Any</option>
                        {isCategories
                          ? 'Loading...'
                          : Object.values(categories)?.map((c, i) => {
                              return (
                                <option key={i} value={c}>
                                  {c}
                                </option>
                              )
                            })}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={6} lg={4} xl={3}>
                    <FloatingLabel controlId='floatingSelect' label='Speciality'>
                      <Form.Select required value={filters.speciality} onChange={handleChange} name='speciality'>
                        <option value='all'>Any</option>
                        {isSpecialities
                          ? 'Loading...'
                          : specialities.map((s, i) => {
                              return (
                                <option key={i} value={s}>
                                  {s}
                                </option>
                              )
                            })}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={6} lg={4} xl={3}>
                    <FloatingLabel controlId='Date' label='Date'>
                      <Form.Select required value={filters.date} onChange={handleChange} name='date'>
                        <option value='all'>Any</option>
                        <option value='this_week'>This Week</option>
                        <option value='this_month'>This Month</option>
                        <option value='this_year'>This Year</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={6} lg={4} xl={3}>
                    <FloatingLabel controlId='floatingSelect' label='Gender'>
                      <Form.Select required value={filters.gender} onChange={handleChange} name='gender'>
                        <option value='all'>Any</option>
                        <option value='male'>Male</option>
                        <option value='female'>Female</option>
                        <option value='prefer_not_to_say'>Prefer Not To Say</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={6} lg={4} xl={3}>
                    <FloatingLabel label='Min Age'>
                      <Form.Control type='number' min={2} max={99} onChange={handleChange} name='minAge' value={filters.minAge} />
                    </FloatingLabel>
                  </Col>
                  <Col md={6} lg={4} xl={3}>
                    <FloatingLabel label='Max Age'>
                      <Form.Control type='number' min={2} max={99} onChange={handleChange} name='maxAge' value={filters.maxAge} />
                    </FloatingLabel>
                  </Col>
                  <Col md={6} lg={4} xl={3}>
                    <Button className='common-btn w-100 py-3' onClick={reset}>
                      Reset
                    </Button>
                  </Col>
                </Row>
              </div>
            </Collapse>
          </div>

          {/* <div className='page-break' /> */}

          <Cummulative filters={filters} />
        </Container>
      )}
    </>
  )
}

export default SubjectInsights

export const colorsLight = ['#b5d8a6', '#f8c995', '#de8ed2', '#91d3d9']
export const colorsDefault = ['#6AB04C', '#F0932B', '#BC1CA4', '#22A6B3']
export const colorsDark = ['#558d3d', '#c07622', '#961683', '#1b858f']
